const googleMapsApiKey =
  process.env.REACT_APP_GOOGLE_API_KEY ||
  process.env.REACT_APP_GOOGLE_PLACES_API_KEY ||
  "";

export const GOOGLE_MAPS_JS_LOADER_OPTIONS = {
  id: "google-map-script",
  googleMapsApiKey,
  libraries: ["places"],
  preventGoogleFontsLoading: true,
};
